/* ----- cart.js ----- */
class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

class CartSubscriptionUpgrade extends HTMLElement {
  constructor() {
    super();

    this.els();
    this.getData();
    this.listeners();
  }

  els() {
    this.cartItems = this.closest('cart-items');
    this.el = this.querySelector('[data-cart-subscription-upgrade]')
  }

  getData() {
    this.data = JSON.parse(this.el.dataset.cartSubscriptionUpgrade);
  }

  listeners() {
    this.el.addEventListener('click', e => {
      e.preventDefault();
      this.updateCart();
    });
  }

  // Remove item and add back as subscription
  updateCart() {
    const {id, quantity, selling_plan} = this.data;

    const properties = {};
    this.data.properties.forEach(prop => {
      properties[prop[0]] = prop[1]
    });

    const addData = {
      items: [{
        id,
        properties,
        quantity,
        selling_plan,
      }]
    };

    const removeData = {
      id: this.data.key,
      quantity: 0
    };

    // Enable loading state on line item
    this.cartItems.enableLoading(this.data.line);

    // Add new size
    fetch(`${window.Shopify.routes.root}cart/add.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(addData)
    })
    .then(response => {
      return response.json();
    })
    .then(() => {
      // Remove old size
      fetch(`${window.Shopify.routes.root}cart/change.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(removeData)
      })
      .then(response => {
        return response.json();
      })
      .then(() => {
        window.updateCart();
      })
      .catch(error => console.error('Error:', error));
    })
    .catch(error => console.error('Error:', error));
  }
}

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {}

  disconnectedCallback() {}

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'), event.target.dataset.quantityVariantId);
    window.loyaltylion.ui.refresh();
  }

  onCartUpdate() {
    fetch(`${routes.cart_url}?section_id=main-cart-items`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const sourceQty = html.querySelector('cart-items');
        this.innerHTML = sourceQty.innerHTML;
        window.loyaltylion.ui.refresh();
      })
      .catch((e) => {
        console.error(e);
      });
  }

  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '#cartDrawerInner',
      },
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer')?.dataset.id,
        selector: '.js-contents',
      },
    ];
  }

  updateQuantity(line, quantity, name, variantId) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement = document.getElementById(`Quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section) => {
          const sectionEL = document.getElementById(section.id);
          if (!sectionEL) return;

          const elementToReplace = sectionEL.querySelector(section.selector) || sectionEL;
          if (!elementToReplace) return;

          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });

        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';

        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem = document.getElementById(`CartItem-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner'), cartDrawerWrapper.querySelector('a'));
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        }

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
      })
      .catch(error => {
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        if (!errors) return;
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
        const customerLoyaltyPoints = document.querySelector('[data-customer-loyalty-points]');
        window.loyaltylion.ui.fetchAndUpdateCart();
        window.loyaltylion.ui.refresh();
        if(!customerLoyaltyPoints) {
          setTimeout(() => {
            window.loadMinicart();
          }, 2000); 
        }
        else {
          const initialPoints = Number(customerLoyaltyPoints.innerText.replaceAll(',', ''));
          const checkPoints = async (attempt) => {
            const updatedElement = document.querySelector('[data-customer-loyalty-points]');
            let newPoints = Number(updatedElement.innerText.replaceAll(',', ''));
            if(!(newPoints > initialPoints)) throw new Error("Network error");
            setTimeout(() => {
              window.loadMinicart();
            }, 300); 
            return "Success!";
          }; 

          window.retryLoyaltyRefresh(checkPoints)
            .then(result => console.log(result))
            .catch(error => {});
        }
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError = document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);

    if (lineItemError) {
      if (typeof message !== 'undefined' && message !== '') lineItemError.removeAttribute('hidden');
      lineItemError.querySelector('.cart-item__error-text').innerHTML = message;
    }

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    if (!cartStatus) return;

    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    if (!(html || selector)) return;
    const $selector = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    if (!$selector) return;
    return $selector.innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items');
    mainCartItems.classList.add('pointer-events');

    const cartItems = this.querySelectorAll(`#CartItem-${line}`);
    cartItems.forEach((item) => item.classList.add('loading'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items');
    mainCartItems?.classList.remove('pointer-events');

    const cartItems = this.querySelectorAll(`#CartItem-${line}`);
    cartItems.forEach((item) => item.classList.remove('loading'));
    document.dispatchEvent(new CustomEvent('CartItemsOnChange'));
    document.dispatchEvent(new CustomEvent('cart-disable-loading'));
  }
};

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'input',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}

/* ----- quantity-popover.js ----- */
if (!customElements.get('quantity-popover')) {
  customElements.define(
    'quantity-popover',
    class QuantityPopover extends HTMLElement {
      constructor() {
        super();
        this.mql = window.matchMedia('(min-width: 990px)');
        this.mqlTablet = window.matchMedia('(min-width: 750px)');
        this.infoButtonDesktop = this.querySelector('.quantity-popover__info-button--icon-only');
        this.infoButtonMobile = this.querySelector('.quantity-popover__info-button--icon-with-label');
        this.popoverInfo = this.querySelector('.quantity-popover__info');
        this.closeButton = this.querySelector('.button-close');
        this.variantInfo = this.querySelector('.quantity-popover-container');
        this.eventMouseEnterHappened = false;

        if (this.closeButton) {
          this.closeButton.addEventListener('click', this.closePopover.bind(this));
        }

        if (this.popoverInfo && this.infoButtonDesktop && this.mql.matches) {
          this.popoverInfo.addEventListener('mouseenter', this.closePopover.bind(this));
        }

        if (this.infoButtonDesktop) {
          this.infoButtonDesktop.addEventListener('click', this.togglePopover.bind(this));
          this.infoButtonDesktop.addEventListener('focusout', this.closePopover.bind(this));
        }

        if (this.infoButtonMobile) {
          this.infoButtonMobile.addEventListener('click', this.togglePopover.bind(this));
          this.infoButtonMobile.addEventListener('focusout', this.closePopover.bind(this));
        }

        if (this.infoButtonDesktop && this.mqlTablet.matches) {
          this.variantInfo.addEventListener('mouseenter', this.togglePopover.bind(this));
          this.variantInfo.addEventListener('mouseleave', this.closePopover.bind(this));
        }
      }

      togglePopover(event) {
        event.preventDefault();
        if (event.type === 'mouseenter') {
          this.eventMouseEnterHappened = true;
        }

        if (event.type === 'click' && this.eventMouseEnterHappened) return;

        const button = this.infoButtonDesktop && this.mql.matches ? this.infoButtonDesktop : this.infoButtonMobile;
        const isExpanded = button.getAttribute('aria-expanded') === 'true';

        button.setAttribute('aria-expanded', !isExpanded);

        this.popoverInfo.toggleAttribute('hidden');

        const isOpen = button.getAttribute('aria-expanded') === 'true';

        button.classList.toggle('quantity-popover__info-button--open');

        if (isOpen && event.type !== 'mouseenter') {
          button.focus();
        }
      }

      closePopover(event) {
        event.preventDefault();
        const isChild = this.variantInfo.contains(event.relatedTarget);

        const button = this.infoButtonDesktop && this.mql.matches ? this.infoButtonDesktop : this.infoButtonMobile;

        if (!event.relatedTarget || !isChild) {
          button.setAttribute('aria-expanded', 'false');
          button.classList.remove('quantity-popover__info-button--open');
          this.popoverInfo.setAttribute('hidden', '');
        }

        this.eventMouseEnterHappened = false;
      }
    }
  );
}

/* ---- cart-drawer.js ----- */
class CartDrawer extends HTMLElement {
  constructor() {
    if (window.CartDrawerInit) return;

    super();
    window.addEventListener('keyup', (evt) => evt.code === 'Escape' && document.documentElement.classList.contains('cart-drawer--active') && this.close());
    this.querySelector('#cartDrawerOverlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();

    if (window.location.hash === '#cart' || window.triggerCartOpen) {
      history.replaceState(null, null, ' ');
      this.open();
      requestAnimationFrame(() => {
        window.updateCart();
      });
    }

    window.CartDrawerInit = true;
  }

  setHeaderCartIconAccessibility() {
    if (window.location.pathname === '/cart') return;

    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    /* cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    }); */
  }

  open(triggeredBy) {
    document.dispatchEvent(new CustomEvent('cart-drawer-opened'));

    cartDrawerInner.scroll(0, 0);

    if (this.querySelector('[data-cart-recs]')) {
      window.loadSwiper();
    }

    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);

    requestAnimationFrame(() => {
      lockScrollEnable();
      document.documentElement.classList.add('cart-drawer--active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
        window.updateCartCount();
        window.loyaltylion.ui.refresh();
      },
      { once: true }
    );
  }

  close() {
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
    document.documentElement.classList.remove('cart-drawer--active');
    lockScrollDisable();
    window.updateCartCount();
    setTimeout(() => {
      document.dispatchEvent(new CustomEvent('cart-drawer-closed'));
    }, 250);
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });
    window.loyaltylion.ui.refresh();
    setTimeout(() => {
      this.querySelector('#cartDrawerOverlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#cartDrawerInner',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
    this.limitedUpdate = this.hasAttribute('data-limited-update') && this.dataset.limitedUpdate === 'true';
    this.productDetailEl = this.closest('product-detail');
    this.sectionId = this.dataset.section;
    this.producetDetailId = this.productDetailEl.dataset.sectionId;
    this.shouldUpdateUrl = this.productDetailEl?.dataset.hasCustomProduct !== 'true';
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();

    if (!this.limitedUpdate) {
      this.toggleAddButton(true, '', false);
    }

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateOptionsLegend();
      this.updateVariantInput();
      this.renderProductInfo();
      // this.renderSubscriptionWidget();

      if (!this.limitedUpdate) {
        this.slideToVariantImage();
        this.updateSku();
        if (this.shouldUpdateUrl) this.updateURL();
      } else {
        this.updateSetInputs();
      }
    }
  }

  slideToVariantImage() {
    if (!this.currentVariant) return;
    const thumbs = this.productDetailEl.querySelector(`#thumbs-${this.sectionId}`);
    const thumb = thumbs?.querySelector(`[data-variant-image*="${this.currentVariant.id}"]`);
    if (!thumb) return;
    const index = parseFloat(thumb.dataset.swiperSlideIndex);
    thumbs?.swiper?.slideTo(index);
    this.productDetailEl.querySelector(`#pdpMedia-${this.sectionId}`)?.swiper?.slideTo(index);
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateOptionsLegend() {
    this.currentVariant.options.forEach((option, index) => {
      console.log('option ', option)
      console.log('this.currentVariant.options ', this.currentVariant.options)
      console.log('this.currentVariant ', this.currentVariant)
      const replaceText = this.getOptionNameReplaceText() && this.getOptionNameReplaceText().find(o => option === o.title);
      const el = this.querySelector(`[data-product-option-active="${index}"]`);
      el ? el.innerText = replaceText ? replaceText.replace : option : null;
      const ea = this.querySelector(`[data-kit-notice-${this.currentVariant.id}]`);
      const eb = this.querySelector(`[data-product-option-active-message]`);
      console.log('this.currentVariant.id ', this.currentVariant.id)
      console.log('ea ', ea)
      if (eb)
        if (ea != null)
          eb.style.display = 'block';
        else
          eb.style.display = 'none'
        if (ea != null)
          eb.innerHTML=ea?.value;
    });
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find(variant => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });

    window.publish(PUB_SUB_EVENTS.variantChange, {
      sectionId: this.dataset.section,
      currentVariant: this.currentVariant,
    });
  }

  /* updateMedia() {
    if (!this.currentVariant || !this.currentVariant?.featured_media) return;
    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    );
    if (!newMedia) return;
    const parent = newMedia.parentElement;
    parent.prepend(newMedia);
    window.setTimeout(() => { parent.scroll(0, 0) });
  } */

  updateURL() {
    if (!this.currentVariant) return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateSku() {
    if (!(this.currentVariant && document.getElementById('productSku'))) return;
    productSku.innerText = 'Style Number: ' + this.currentVariant.sku.split('-')[0];
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      const sellingPlan = productForm.querySelector('input[name="selling_plan"]');      
      input.value = this.currentVariant.id;
      if (sellingPlan) sellingPlan.value = this.currentVariant.selling_plan_allocations[0]?.selling_plan_id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant?.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  renderSubscriptionWidget() {
    const activeElement = document.activeElement;
    const activeElementId = activeElement.id;

    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}`)
      .then((response) => response.text())
      .then((responseText) => {
        const fetchedHtml = new DOMParser().parseFromString(responseText, 'text/html');
        const subscriptionWidgetId = `#subscriptionWidget-${this.sectionId}`;
        const subscriptionWidgetDestination = this.productDetailEl.querySelector(subscriptionWidgetId);
        const subscriptionWidgetSource = fetchedHtml.querySelector('product-detail[data-has-custom-product="false"] subscription-widget');
        if (subscriptionWidgetSource && subscriptionWidgetDestination) subscriptionWidgetDestination.outerHTML = subscriptionWidgetSource.outerHTML;

        requestAnimationFrame(() => {
          if (activeElementId) document.getElementById(activeElementId)?.focus();
        });
      });
  }

  renderProductInfo() {
    const activeElement = document.activeElement;
    const activeElementId = activeElement.id;
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.sectionId}`)
      .then((response) => response.text())
      .then((responseText) => {
        const fetchedHtml = new DOMParser().parseFromString(responseText, 'text/html');
        const priceId = `#price-${this.sectionId}`;
        const priceDestination = this.productDetailEl.querySelector(priceId);
        const priceSource = fetchedHtml.querySelector(priceId);
        const subscriptionWidgetId = `#subscriptionWidget-${this.sectionId}`;
        const subscriptionWidgetDestination = this.productDetailEl.querySelector(subscriptionWidgetId);
        const subscriptionWidgetSource = fetchedHtml.querySelector(subscriptionWidgetId);

        if (subscriptionWidgetSource && subscriptionWidgetDestination) subscriptionWidgetDestination.outerHTML = subscriptionWidgetSource.outerHTML;
        if (priceSource && priceDestination) {
          priceDestination.innerHTML = priceSource.innerHTML;
          priceDestination.classList.remove('visibility-hidden');
        }

        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut || 'Sold out');

        requestAnimationFrame(() => {
          if (activeElementId) document.getElementById(activeElementId)?.focus();
        });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const addButton = document.getElementById(`product-form-${this.dataset.section}`)?.querySelector('[name="add"]');

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', true);
      if (text) addButton.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButton.innerHTML = `
        <span class="pdp__submit-text pdp__submit-text--default" style="display: var(--adding-display-none, block)">${window.variantStrings.addToCart}</span>
        <span class="pdp__submit-text pdp__submit-text--adding" style="display: var(--adding-display-block, none)">${window.variantStrings.addingToCart}</span>
      `;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const addButton = document.getElementById(`product-form-${this.dataset.section}`)?.querySelector('[name="add"]');
    if (!addButton) return;
    addButton.textContent = window.variantStrings.unavailable;
    document.getElementById(`price-${this.dataset.section}`)?.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"][data-json="product-variants"]').textContent);
    return this.variantData;
  }

  getOptionNameReplaceText() {
    this.optionNameReplaceText = this.optionNameReplaceText || JSON.parse(this.querySelector('[type="application/json"][data-json="option-name-replace-text"]').textContent);
    return this.optionNameReplaceText;
  }

  updateSetInputs() {
    this.querySelectorAll(':checked').forEach(input => {
      const setInput = document.querySelector(`input[data-form-id="${input.getAttribute('form')}"][name$="id"]`);
      if (setInput) setInput.value = this.currentVariant.id;
    });
  }
};

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('[data-product-option]'));
    this.options = fieldsets.map((fieldset) => {
      const inputs = Array.from(fieldset.querySelectorAll('input'));
      return inputs.length === 1 ? inputs[0].value : inputs.length && inputs.find((radio) => radio.checked).value;
    });
  }
};

customElements.define('variant-radios', VariantRadios);

/* ----- globals ----- */
function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function getFocusableElements(container) {
  if (!container) return;

  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

function lockScrollEnable() {
  window.pageY = window.scrollY;
  document.body.style.left = 0;
  document.body.style.right = 'var(--scrollbar-width)';
  document.body.style.top = `-${window.pageY}px`;
  document.body.style.position = 'fixed';
}

function lockScrollDisable() {
  document.body.style.position = null;
  document.body.style.left = null;
  document.body.style.right = null;
  document.body.style.top = null;
  window.scrollTo(0, window.pageY);
}

function loadMinicart() {
  fetch(`${window.Shopify.routes.root}?sections=cart-drawer`)
    .then(response => response.json())
    .then(data => {
      document.querySelector('#cartDrawerInner').innerHTML = (new DOMParser().parseFromString(data['cart-drawer'], 'text/html').querySelector('#cartDrawerInner').innerHTML);
      window.loyaltylion.ui.refresh();
      requestAnimationFrame(() => {
        if (document.querySelector('#cartDrawerInner').querySelector('[data-cart-recs]') || document.querySelector('#cartDrawerInner').querySelector('[data-customer-loyalty-points]')) {
          window.loadSwiper();
        }
      })
    })
}

const wait = (ms) => new Promise(resolve => setTimeout(resolve, ms));

async function retryLoyaltyRefresh(fn, maxAttempts = 5, delay = 1000) {
  for (let attempt = 1; attempt <= maxAttempts; attempt++) {
    try {
      return await fn(attempt); // Execute the function
    } catch (error) {
      if (attempt === maxAttempts) {
        throw new Error(`Operation failed after ${maxAttempts} attempts`);
      }
      await wait(delay); // Wait 1 second before retrying
    }
  }
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  const elements = getFocusableElements(container);

  if (!(elements && elements.length > 0)) return;

  const first = elements[0];
  const last = elements[elements.length - 1];

  if (!(first && last)) return;

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; /* If not TAB key */
    /* On the last focusable element and tab forward, focus the first element. */
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    /*  On the first focusable element and tab backward, focus the last element. */
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

/* Currency formatter */
window.Shopify = window.Shopify || {};
window.Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') {
    cents = cents.replace('.', '');
  }
  var value = '';
  var placeholderRegex = /{{\s*(\w+)\s*}}/;
  var formatString = (format || window.theme?.moneyFormat || '${{amount}}');
  function defaultOption(opt, def) {
      return (typeof opt == 'undefined' ? def : opt);
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal = defaultOption(decimal, '.');
      if (isNaN(number) || number == null) {
          return 0;
      }
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.'),
          dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
          cents = parts[1] ? (decimal + parts[1]) : '';
      return dollars + cents;
  }
  switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
          value = formatWithDelimiters(cents, 2);
          break;
      case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
      case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
          break;
      case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
  }
  return formatString.replace(placeholderRegex, value);
};

if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');

        if (!this.form) return;

        const idInput = this.form.querySelector('[name=id]');
        if (idInput) idInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]') || this.querySelector('[type="add"]');

        if (document.querySelector('cart-drawer')) this.submitButton?.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton && this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        if (this.submitButton) {
          this.submitButton.setAttribute('aria-disabled', true);
          this.submitButton.classList.add('loading');
        }
        this.querySelector('.loading__spinner')?.classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton && this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickviewModal = this.closest('quickview-product');
            this.cart.renderContents(response);
            if (quickviewModal) {
              quickviewModal.close();
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            setTimeout(() => {
              if (this.submitButton) this.submitButton.classList.remove('loading');
            }, 125);
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error && this.submitButton) this.submitButton.removeAttribute('aria-disabled');
            this.closest('.quickadd--loading')?.classList.remove('quickadd--loading');
            this.querySelector('.loading__spinner')?.classList.add('hidden');
            window.loyaltylion.ui.fetchAndUpdateCart();
            window.loyaltylion.ui.refresh();
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

(() => {
  const onScroll = () => {
    if (window.menuToggling) return;


    if (window.pageYOffset > window.headerScrolledThreshold) {
      document.documentElement.classList.add('header--scrolled');
    } else {
      document.documentElement.classList.remove('header--scrolled');
    }

    if (window.pageYOffset > 300 + window.headerScrolledThreshold) {
      document.documentElement.classList.add('header--scrolled--after');
    } else {
      document.documentElement.classList.remove('header--scrolled--after');
    }

    const scrollTop = window.pageYOffset;

    /* scroll direction */
    window.scrollDirection = scrollTop > lastScrollTop ? 'down' : 'up';
    document.documentElement.dataset.scrollDirection = window.scrollDirection;
    lastScrollTop = window.pageYOffset;
  };

  const inViewVideo = (el, src) => {
    const videoEl = el.closest('video');

    if (!videoEl) return;
    if (typeof src !== 'undefined') videoEl.src = el.dataset.inViewVideoSrc;

    if (!videoEl.hasAttribute('data-autoplay')) return;
    /* videoEl.removeAttribute('controls'); */

    videoEl.classList.add('video--autoplaying');
    videoEl.play();
  };

  window.lazyLoadScript = obj => {
    const isLoaded = document.head.querySelector(`[data-in-view-script-name='${obj.src}']`);
    const cb = obj.callback && typeof window[obj.callback] === 'function' ? window[obj.callback] : null;

    if (isLoaded) {
      if (cb) cb();
      return;
    }

    const $script = document.createElement('script');
    $script.dataset.inViewScriptName = obj.src;
    $script.type = obj.type || 'text/javascript';
    if (obj.defer) $script.defer = true;
    else if (obj.async) $script.async = true;
    $script.src = obj.src;
    document.head.appendChild($script);

    if (cb) $script.onload = requestAnimationFrame(() => {
      cb()
    });
  }

  const inViewScript = obj => {
    lazyLoadScript(obj);
  };


  window.loadSwiper = () => {
    /* load swiper if needed */
    if (!window.swiperLoaded && typeof Swiper !== 'function') {
      const $script = document.createElement('script');
      $script.async = true;
      $script.src = window.assetUrls['swiper.js'];
      document.head.appendChild($script);
      window.swiperLoaded = true
    }

    const swiperIsReady = new Promise(resolve => {
      let timer = setInterval(() => {
        if (typeof Swiper === 'function') {
          clearInterval(timer);
          return resolve();
        }
      }, 30)
    });

    swiperIsReady.then(() => {
      window.swipers();
    }).catch(error => {
      console.error('Something went wrong:', error);
    })
  };

  /* swipers init via data-swiper={options} */
  window.swiperEls = [];
  window.swipers = () => {
    document.querySelectorAll('[data-swiper]:not(.swiper-initialized)').forEach((el, index) => {
      window.swiperEls[index] = new Swiper(el, Object.assign({}, {
        a11y: true,
        observer: true,
        slidesPerView: 'auto',
        threshold: 8,
      }, JSON.parse(el.dataset.swiper)));

      const changeEvent = el.getAttribute('data-swiper-slide-change');

      if (changeEvent && window.hasOwnProperty(changeEvent) && typeof window[changeEvent] === 'function') {
        window.swiperEls[index].on('slideChangeTransitionEnd', function(e) {
          window[changeEvent](e);
        })
      }
    });
  };

  window.inView = () => {
    /* add .in-view class to [data-in-view] els as they enter the viewport */
    const inViewEls = document.querySelectorAll('[data-in-view]');

    const inViewObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('in-view');

          if (entry.target.hasAttribute('data-autoplay') || entry.target.hasAttribute('data-in-view-video-src')) {
            inViewVideo(entry.target, entry.target.dataset.inViewVideoSrc);
          }

          if (entry.target.hasAttribute('data-in-view-swiper')) {
            loadSwiper();

            inViewObserver.unobserve(entry.target);
          }

          if (entry.target.hasAttribute('data-in-view-script')) {
            inViewScript(JSON.parse(entry.target.dataset.inViewScript));
          }
        } else {
          if (entry.target.hasAttribute('data-autoplay') && entry.target.paused == false) {
            entry.target.pause()
          }
        }
      });
    });

    inViewEls.forEach(el => inViewObserver.observe(el));
  };

  document.addEventListener('DOMContentLoaded', () => {
    customElements.define('cart-remove-button', CartRemoveButton);
    customElements.define('cart-subscription-upgrade', CartSubscriptionUpgrade);
    customElements.define('cart-items', CartItems);
    customElements.define('cart-drawer', CartDrawer);

    window.lastScrollTop = window.pageYOffset;

    onScroll();
    inView();

    window.addEventListener('scroll', () => {
      onScroll();
    }, { passive: true });
  });

  window.addEventListener('keyup', e => {
    if (e.key === 'Escape') document.dispatchEvent(new CustomEvent('onEsc'));
  });


  window.updateCart = () => {
    /* reload the minicart */
    if (document.querySelector("#cartDrawerInner")) {
      window.loadMinicart();

      /* open the minicart */
      document.querySelector('cart-drawer')?.open();
    } else {
      /* reload the cart page */
      document.querySelector('cart-items')?.onCartUpdate();
    }

    /* update cart bubble count in header */
    fetch(`${routes.cart_url}?section_id=cart-icon-bubble`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        document.querySelector('#cart-icon-bubble').innerHTML = html.querySelector('#shopify-section-cart-icon-bubble').innerHTML;
      })
      .catch((e) => {
        console.error(e);
      });

    /* update free shipping message in announcement bar */
    fetch(`${routes.cart_url}.js`)
      .then(response => response.json())
      .then(data => {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'product-form-cart-total',
          cartData: data,
        });
      });

    window.loyaltylion.ui.refresh();
  };

  window.updateCartCount = (delay = 300) => {
    requestAnimationFrame(() => {
      const $count = document.querySelector('[data-cart-icon-bubble-count]');
      const count = $count ? $count.innerText : 1
      /* wait for cart-drawer transition to finish then update data-cart-count which is used to adjust the padding next to cart icon in header*/
      setTimeout(() => {
        document.documentElement.dataset.cartCount = count
      }, delay);
    });
  }

  document.addEventListener('CartItemsOnChange', () => {
    window.updateCartCount();
  })

  // LoyaltyLion events
  // note: LoyaltyLion always emit a `cart.changed` event at the same time as the other cart.*
  // events
  lion.on("cart.changed", function() {
    window.loadMinicart();
  });


  lion.on("cart.addedItem", function(data) {
    window.loadMinicart();
  });

  document.addEventListener('CartItemsOnChange', () => {
    window.updateCartCount();
  })

  async function updateCartWithUTMParams() {
    try {
      const params = new URLSearchParams(window.location.search);
      const utmParams = {};

      // Collect utm_* params from the URL
      for (const [key, value] of params.entries()) {
        if (key.startsWith('utm_')) {
          utmParams[key] = value;
        }
      }

      // If any utm_* params found, add to the cart
      if (Object.keys(utmParams).length > 0) {
        const res = await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            attributes: { ...utmParams }
          })
        });

        const updatedCart = await res.json();
        console.log('Cart updated with UTM params:', updatedCart.attributes);
      }
    } catch (err) {
      console.error('Error updating cart with UTM params:', err);
    }
  }

  updateCartWithUTMParams();
})();